<template>
  <div>
    <div
      class="local-wrapper"
      :style="{
        background: slideData.background_color,
        color: slideData.text_color,
      }"
    >
      <div
        v-if="slideData.include_copy"
        class="local-description-box"
        v-html="slideData.slide_text"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'feature',
  props: {
    slideData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped>
.local-wrapper {
  position: fixed;
  /* background: rgba(76, 175, 80, 0.5); */
  min-height: 500px;
  bottom: 0;
  height: 100%;
  width: 50%;
}
.local-description-box {
  color: inherit;
  text-align: left;
  padding-left: 100px;
  padding-top: 125px;
  font-size: 70px;
  width: 90%;
}
</style>
